const DATA_NAMESPACE = {
  page: 'viddsee-page',
  click: 'v-click',
  doIf: {
    doIf: 'v-do-if',
  },
};

export default DATA_NAMESPACE;
